import { default as emptyStateDark } from "~/assets/empty-state-dark.svg"
import queryFailLight from "~/assets/query-fail-light.svg"
import useGlobalStore from "~/store/global"
import { useTranslation } from "react-i18next"

const QueryFail = () => {
  const { t } = useTranslation()
  const appTheme = useGlobalStore((store) => store.appTheme)
  const isDarkMode = appTheme === "dark"

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="flex justify-center items-center flex-col gap-2 mt-20">
        <div className="p-4 rounded-lg">
          <img
            key={"empty-state-icon"}
            src={isDarkMode ? emptyStateDark : queryFailLight}
            width={167}
            height={100}
            alt="empty-state-icon"
            className="text-xl text-neutral-50 dark:text-neutral-800"
          />
        </div>
        <p className="text-13 font-semibold text-dark-2 dark:text-dark-6 w-full text-center">
          {t("k_os.label_we_ran_into_issue_fetching_data_brief")}
        </p>
        <p className="text-13 font-semibold text-dark-2 dark:text-dark-6 w-full text-center">
          {t("k_os.label_for_help_contact")}{" "}
          <span className="text-primary cursor-pointer">
            support@orbitshift.ai
          </span>
        </p>
      </div>
    </div>
  )
}

export default QueryFail
